import * as React from 'react';
import { Accordion } from 'damco-components';
import Table from 'components/data-table/Table';
import { IBProps } from '../../utils/models';
import PropertyDisplay from 'components/cost-revenue/PropertyDisplay';
import { formatData, formatValueIfNullOrUndefined, simplifyNull } from 'utilities/util';

export default class BookingDetails extends React.Component<IBProps> {
    public createLink = (data: any, target: string) => {
        switch (target) {
            case 'fcr':
                this.props.link(String(`/job-costing/documents/${data!.fcrId}`));
                break;
            case 'cbl':
                this.props.link(String(`/job-costing/cbls/${data!.id}`));
                break;
            case 'equipment':
                this.props.link(String(`/job-costing/equipments/${data!.equipmentId}`));
                break;
        }
    };
    public render() {
        const newFcr = JSON.parse(JSON.stringify(this.props.fcr));
        newFcr.data.map((child: any) => {
            child.placeOfReceiptName = simplifyNull(child.placeOfReceiptCode, child.placeOfReceiptName);
            child.portOfDischargeName = simplifyNull(child.portOfDischargeCode, child.portOfDischargeName);
            child.placeOfDeliveryName = simplifyNull(child.placeOfDeliveryCode, child.placeOfDeliveryName);
            child.portOfLoadingName = simplifyNull(child.portOfLoadingCode, child.portOfLoadingName);
            child.shipmentType = formatValueIfNullOrUndefined(child.shipmentTypeAtOrigin) + '/' + formatValueIfNullOrUndefined(child.shipmentTypeAtOrigin);
        });

        const extraDocs = JSON.parse(JSON.stringify(newFcr));
        if (extraDocs.data && extraDocs.data.length) {
            extraDocs.data = extraDocs.data.filter((val: any) => val.originalDocumentNumber && val.originalDocumentNumber.startsWith('EED'));
        }
        const exceptExtraDocs = JSON.parse(JSON.stringify(newFcr));
        if (exceptExtraDocs.data && exceptExtraDocs.data.length) {
            exceptExtraDocs.data = exceptExtraDocs.data.filter((val: any) => val.originalDocumentNumber && !val.originalDocumentNumber.startsWith('EED'));
        }
        const newCbl = JSON.parse(JSON.stringify(this.props.cbl));
        newCbl.data.map((child: any) => {
            child.placeOfReceiptName = `${child.placeOfReceiptName}`;
            child.originalPortOfLoadingName = `${child.originalPortOfLoadingName} (${child.originalPortOfLoadingCode})`;
            child.finalPortOfDischargeName = `${child.finalPortOfDischargeName} (${child.finalPortOfDischargeCode})`;
            child.placeOfDeliveryName = `${child.placeOfDeliveryName} (${child.placeOfDeliveryCode})`;
        });
        const newCLR = { ...this.props.clr };
        if (newCLR && newCLR.data) {
            newCLR.data = newCLR.data.map((data: any) => {
                const newData = formatData([data]);
                return newData[0];
            });
        }

        return (
            <div className="padding-top-large padding-bottom-large">
                <Accordion title={'Organisation'} id="organisation">
                    <PropertyDisplay data={[...this.props.organisation]} id="organisation" />
                </Accordion>
                <Accordion title={'Locations'} id="locations">
                    <PropertyDisplay data={[...this.props.locations]} id="locations" />
                </Accordion>
                <Accordion title={'Cargo details'} id="cargoDetails">
                    <PropertyDisplay className="col-20" data={[...this.props.cargoDetails]} id="cargoDetails" />
                </Accordion>
                <Accordion title={'Job Id details'} id="jobIdDetailsCollapse">
                    <PropertyDisplay data={[...this.props.jobIdDetails]} id="jobIdDetails" />
                </Accordion>
                {!this.props.isExtraDocumentFeatureEnabled &&
                    <Accordion title={'Fcr'} id="fcr">
                        <Table {...newFcr}
                            id="booking-details-fcr"
                            hasTotal={true}
                            linkAction={(row: any) => { this.createLink(row, 'fcr'); }} />
                    </Accordion>
                }
                {this.props.isExtraDocumentFeatureEnabled &&
                    <Accordion title={'Document'} id="fcr">
                        <Table {...exceptExtraDocs}
                            id="booking-details-fcr"
                            hasTotal={true}
                            linkAction={(row: any) => { this.createLink(row, 'fcr'); }} />
                    </Accordion>
                }
                {this.props.isExtraDocumentFeatureEnabled &&
                    extraDocs.data &&
                    extraDocs.data.length > 0 &&
                    <Accordion title={'Export Extra Document'} id="extra-document">
                        <Table {...extraDocs}
                            id="booking-details-extra-document"
                            hasTotal={true}
                            linkAction={(row: any) => { this.createLink(row, 'fcr'); }} />
                    </Accordion>
                }
                <Accordion title={'clr'}>
                    <Table {...newCLR}
                        id="booking-details-clr"
                        hasTotal={true}
                    />
                </Accordion>
                <Accordion title={'Equipment'} id="equipments">
                    <Table {...this.props.equipments}
                        id="booking-details-equipment"
                        hasTotal={true}
                        linkAction={(row: any) => { this.createLink(row, 'equipment'); }} />
                </Accordion>
                <Accordion title={'CBL'} id="cbl">
                    <Table {...newCbl}
                        id="booking-details-cbl"
                        linkAction={(row: any) => { this.createLink(row, 'cbl'); }}
                        hasTotal={true} />
                </Accordion>
            </div>
        );
    }
}